"use client";

import Image from "next/image";
import { useState } from "react";
import Loader from "../Loader";
import styles from "./brand.module.css";

const BrandArea = ({ df, brands = [] }: { df?: boolean; brands?: any[] }) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <Loader />}
      <div className={styles.wrap}>

        {/* ═══ HERO ═══ */}
        <section className={styles.hero}>
          <div className={styles.heroCanvas} />

          <div className={styles.heroContent}>
            <div className={styles.heroLeft}>
              <span className={styles.heroEyebrow}>iMall · Brand Directory</span>

              <h1 className={styles.heroTitle}>
                Every Great<br />
                Brand, In<br />
                <span className={styles.heroTitleEm}>One Place.</span>
              </h1>

              <p className={styles.heroSub}>
                Curated collection of {brands.length}+ world-class brands.<br />
                Authentic. Trusted. Delivered.
              </p>

              <div className={styles.heroPills}>
                {["100% Authentic", "Fast Delivery", "Easy Returns"].map((p) => (
                  <span key={p} className={styles.heroPill}>{p}</span>
                ))}
              </div>

              <div className={styles.heroCtas}>
                <a href="#brands" className={styles.ctaPrimary}>Explore Brands</a>
                <a href="/shop" className={styles.ctaSecondary}>Shop All →</a>
              </div>
            </div>

            <div className={styles.heroRight}>
              <div className={styles.heroBigNum}>
                <span className={styles.numValue}>{brands.length}</span>
                <span className={styles.numLabel}>Premium<br />Brands</span>
              </div>

              <div className={styles.heroChips}>
                {brands.slice(0, 5).map((b: any, i: number) => (
                  <div
                    key={i}
                    className={styles.chip}
                    style={{ "--d": `${i * 0.1}s` } as React.CSSProperties}
                  >
                    <div className={styles.chipLogo}>
                      <Image
                        src={b?.image ?? "/noimage.png"}
                        alt=""
                        width={36}
                        height={36}
                        className={styles.chipImg}
                      />
                    </div>
                    <span className={styles.chipName}>{b?.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles.heroCut} />
        </section>

        {/* ═══ BRAND GRID ═══ */}
        <section className={styles.brandsSection} id="brands">
          <div className={styles.brandsInner}>

            <div className={styles.sectionLabel}>
              <div className={styles.labelLine} />
              <span className={styles.labelText}>All Brands</span>
              <div className={styles.labelLine} />
            </div>

            <div className={styles.brandGrid}>
              {brands.map((brand: any, i: number) => (
                <a
                  key={i}
                  href={`/shop?brand=${brand?.id}`}
                  onClick={() => setLoading(true)}
                  className={styles.bcard}
                  style={{ animationDelay: `${Math.min(i * 55, 550)}ms` }}
                >
                  <span className={styles.bcardWm}>{String(i + 1).padStart(2, "0")}</span>

                  <div className={styles.bcardLogo}>
                    <Image
                      src={brand?.image ?? "/noimage.png"}
                      alt={brand?.name || "brand"}
                      width={88}
                      height={88}
                      className={styles.bcardImg}
                    />
                  </div>

                  <div className={styles.bcardInfo}>
                    <h3 className={styles.bcardName}>{brand?.name || "Brand"}</h3>
                    <span className={styles.bcardVerified}>✓ Verified Partner</span>
                  </div>

                  <div className={styles.bcardOverlay}>
                    <span className={styles.bcardShop}>Shop Brand →</span>
                  </div>
                </a>
              ))}
            </div>

            <div className={styles.brandsFooter}>
              <a href="/shop" className={styles.footerBtn}>
                <span>View All Products</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </a>
            </div>

          </div>
        </section>

      </div>
    </>
  );
};

export default BrandArea;